import { clientInformation } from "@discovery/common-dplus/lib/device-info";
import { useEffect, useGlobalState, useState, } from "@discovery/common-dplus/lib/hooks";
import { _Config } from "@discovery/common-dplus/lib/state";
import * as App from "@discovery/maestro";
import { envBrowser } from "@discovery/maestro-env-browser";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { compose } from "@discovery/prelude/lib/data/function";
import * as M from "@discovery/prelude/lib/data/maybe";
import { _Col2TemplateId, _ColAttributes2Description, } from "@discovery/sonic-api-ng-optics";
import * as CQ from "@discovery/sonic-api-ng/lib/api/common/query";
import * as Products from "@discovery/sonic-api-ng/lib/api/monetization/products";
import * as E from "fp-ts/Either";
import { pipe } from "fp-ts/function";
import * as Option from "fp-ts/Option";
import { PricePlannerView } from "../../components/molecules/price-planner";
import { ProductId, _SubscribeNowCtaTitle, _ButtonTitle, _CoverImageDesktop, _CoverImageMobile, _PriceplanV2, } from "./optics";
import PrimaryPlan from "./primary-plan-view";
const Template = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
};
const PricePlanView = ({ data, read }) => {
    const _list = Fold.toArray(_PriceplanV2, data);
    const coverImageDesktopM = Fold.preview(_CoverImageDesktop, data);
    const coverImageMobileM = Fold.preview(_CoverImageMobile, data);
    const templateIdM = Fold.preview(_Col2TemplateId, data);
    const buttonTitleM = Fold.preview(_ButtonTitle, data);
    const ctaTitle = Fold.preview(_SubscribeNowCtaTitle, data);
    const [configM] = useGlobalState(_Config);
    const premiumPackagesM = M.chain((x) => x.premiumPackages, configM);
    const premiumPackages = M.fromMaybe(premiumPackagesM, []);
    const list = _list.map((x) => {
        const bodyM = Option.some({
            blocks: [
                {
                    data: pipe(x.contentBlocks.data, Option.getOrElse(() => ({}))),
                    depth: pipe(x.contentBlocks.depth, Option.getOrElse(() => 0)),
                    key: pipe(x.contentBlocks.key, Option.getOrElse(() => Math.random().toString())),
                    text: x.contentBlocks.text,
                    type: x.contentBlocks.type,
                    entityRanges: pipe(x.contentBlocks.entityRanges, Option.getOrElse(() => [])),
                    inlineStyleRanges: pipe(x.contentBlocks.inlineStyleRanges, Option.getOrElse(() => [])),
                },
            ],
            entityMap: pipe(M.of(x.entityMap), Option.getOrElse(() => ({}))),
        });
        const data = {
            period: x.period,
            bodyM: bodyM,
        };
        return data;
    });
    const pricingM = M.chain((x) => x.pricing, configM);
    const pricing = M.fromMaybe(pricingM, {
        campaignsEnabled: M.of(false),
        approvedPricePlans: M.of([""]),
        preferredPricePlan: M.of({ id: M.of(""), label: M.of("") }),
    });
    const campaignsEnabled = M.fromMaybe(pricing.campaignsEnabled, false);
    const approvedPricePlan = M.fromMaybe(pricing.approvedPricePlans, [""]);
    const preferredPricePlan = M.fromMaybe(pricing.preferredPricePlan, {
        id: M.of(""),
        label: M.of(""),
    });
    const [pricePlans, setPricePlans] = useState([]);
    const getProductList = () => {
        const premiumPackageId = premiumPackages[0];
        const request = Products.Endpoints.getProducts(compose(Products.Query.lenses.decorators.set(CQ.Decorators.decorators("articleBodyRichText.richTextHtml")), Products.Query.lenses.filters.set(CQ.Filters.filters(CQ.Filter.filterOr("productType", "MAIn"), CQ.Filter.filterOr("package.id", premiumPackageId))), Products.Query.lenses.include.set(CQ.Include.include("pricePlan", "pricePlan.body", "package", "pricePlan.campaign")))(Products.Query.parameters));
        return App.run(request)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
            /* handle exception here */
        }, (response) => {
            const pricePlans = Fold.toArray(ProductId, response);
            setPricePlans(pricePlans);
        }));
    };
    const PricePlanner = () => {
        const templateId = M.fromMaybe(templateIdM, "");
        const descriptionM = templateId === Template.PRIMARY
            ? Fold.preview(Fold.compose(_ColAttributes2Description, M._Just()), data)
            : M.of("");
        const primaryPricePlan = [];
        pricePlans.map((item) => {
            const tempArr = Object.assign({}, item);
            return approvedPricePlan.map((child) => {
                if (item.id === child) {
                    return primaryPricePlan.push(tempArr);
                }
                else {
                    return;
                }
            });
        });
        const secondaryPricePlans = [];
        primaryPricePlan.map((item) => {
            return list.map((child) => {
                if (item.period === child.period) {
                    const tempArr = Object.assign({ description: child.bodyM }, item);
                    return secondaryPricePlans.push(tempArr);
                }
                else {
                    return;
                }
            });
        });
        switch (templateId) {
            case Template.PRIMARY:
                return (React.createElement(PrimaryPlan, { buttonTitleM: ctaTitle, read: read, campaignsEnabled: campaignsEnabled, descriptionM: descriptionM, coverImageMobileM: coverImageMobileM, coverImageDesktopM: coverImageDesktopM, pricePlans: primaryPricePlan, preferredPricePlan: preferredPricePlan }));
            case Template.SECONDARY:
                return (React.createElement(PricePlannerView, { buttonTitleM: buttonTitleM, pricePlans: secondaryPricePlans, read: read }));
            default:
                return (React.createElement(PrimaryPlan, { read: read, campaignsEnabled: campaignsEnabled, descriptionM: descriptionM, coverImageMobileM: coverImageMobileM, coverImageDesktopM: coverImageDesktopM, pricePlans: primaryPricePlan, preferredPricePlan: preferredPricePlan, buttonTitleM: ctaTitle }));
        }
    };
    useEffect(() => {
        getProductList();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return React.createElement(PricePlanner, null);
};
export default PricePlanView;

